module.exports = __webpack_public_path__ + "static/media/BOG-2.08d234de.pdf";